import ModalTabs from '@/vue/components/Modals/ModalTabs';

export const TabbedModalMixin = {
    components: {
        ModalTabs,
    },

    data() {
        return {
            selectedTab: null,

            /**
             * @type {{name: string, icon: string, label: string, component: string}[]}
             */
            tabs: [],
        };
    },

    created() {
        // Select the first tab initially.
        this.selectedTab = this.tabs[0];
    },

    methods: {
        async selectTab(tab) {
            if (tab === this.selectedTab) {
                return;
            }

            // Tell the currently selected tab we are navigating away.
            if (this.$refs['current-tab-component']?.beforeTabAway) {
                try {
                    await this.$refs['current-tab-component']?.beforeTabAway();
                } catch (e) {
                    console.warn('Switching tabs was prevented by current tab.', e);
                    return;
                }
            }

            this.selectedTab = tab;
        },

        /**
         * @param {string} name
         */
        selectTabName(name) {
            const tab = this.tabs.find((t) => t.name === name);
            if (tab) {
                this.selectTab(tab);
            }
        },
    },
};
